"use client";

import React, { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";

// 1. Dán link ảnh của bạn vào đây
const HOT_STICKER_URL = "https://p2wstore.com/wp-content/uploads/2026/06/hot.png";
const GAME_IMAGES: Record<string, string> = {
  "Dragon Nest SEA": "https://p2wstore.com/wp-content/uploads/2026/04/1-2.png",
  "Pokemon Go": "https://p2wstore.com/wp-content/uploads/2026/05/1.png",
  "Rise of Kingdom": "https://link-anh-cua-ban.com/rok.png"
  // Thay tên game và link ảnh vào nếu có game mới
};
const getGameImage = (title: string) => {
  return GAME_IMAGES[title] || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/game_placeholder.png";
};
function MarketGrid() {
  const {
    posts,
    loading
  } = usePosts();
  const randomGames = useMemo(() => {
    if (!posts || posts.length === 0) return [];
    return [...posts].sort(() => 0.5 - Math.random()).slice(0, 4);
  }, [posts]);
  if (loading) return <div className="text-center py-20 text-muted-foreground">Đang tải...</div>;
  if (!posts || posts.length === 0) return <div className="text-center py-20 text-muted-foreground">Không tìm thấy dữ liệu.</div>;
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {randomGames.map(game => <Link key={game.id} to={game.link || "#"} className="group block w-full">
          
          {/* Khung card: Thêm pb-2 để tạo khoảng cách nếu cần */}
          <div className="relative w-full border border-primary/40 bg-card/50 backdrop-blur-sm rounded-xl overflow-hidden shadow-lg transition-all duration-500 group-hover:scale-[1.03] group-hover:shadow-[0_0_25px_rgba(34,211,238,0.4)]">
            <AspectRatio ratio={2 / 3}>
              
              {/* Sticker HOT: Tự động scale theo khung */}
              <div className="absolute -top-1 -right-1 z-40 w-20 h-20 animate-pulse">
                <img src={HOT_STICKER_URL} alt="HOT" className="w-full h-full object-contain" />
              </div>
    
              {/* Hình game */}
              <div className="absolute inset-0 p-1.5">
                <img src={getGameImage(game.title)} alt={game.title} className="w-full h-full object-cover rounded-lg shadow-2xl transition-transform duration-500 group-hover:scale-105" />
              </div>
              
              {/* Tên game: Chỉnh font-size linh hoạt (text-lg trên mobile, text-xl trên desktop) */}
              <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black/90 to-transparent">
                <h3 className="text-lg md:text-xl font-extrabold uppercase text-center text-cyan-400 transition-colors duration-300 group-hover:text-white truncate">
                  {game.title}
                </h3>
              </div>
            </AspectRatio>
          </div>
        </Link>)}
    </div>;
}
export default function GameSelection() {
  return <section id="productlisting" className="bg-background text-foreground relative overflow-hidden ![padding:50px_0px_96px_0px]">
      <div className="pointer-events-none absolute inset-0 z-0 opacity-5 bg-[linear-gradient(to_right,#3b82f6_1px,transparent_1px),linear-gradient(to_bottom,#3b82f6_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <h2 className="font-serif text-5xl font-bold uppercase leading-none tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-primary via-blue-400 to-cyan-400 md:text-7xl drop-shadow-[0_0_15px_rgba(59,130,246,0.5)]">
            p2w MARKET
          </h2>
          <div className="relative group">
            <div className="absolute -inset-0.5 rounded-md bg-primary opacity-30 blur-md transition duration-300 group-hover:opacity-100"></div>
            <Link to="/games">
              <Button variant="outline" size="lg" className="relative border-2 border-primary/50 bg-card/50 backdrop-blur-sm text-primary hover:bg-primary hover:text-primary-foreground font-mono uppercase tracking-widest transition-all duration-300">Menu Game</Button>
            </Link>
          </div>
        </div>

        <PostsProvider wp_query={{
        post_type: "page",
        post_parent: 120,
        per_page: 50,
        lang: "en"
      }}>
          <MarketGrid />
        </PostsProvider>
      </div>
    </section>;
}